import angular from 'angular';
import _ from 'lodash-es';

angular.module('shbdeployer.app').controller('TagsController', TagsController);

function TagsController($scope, $state, $async, TagService, Notifications) {
  $scope.state = {
    actionInProgress: false,
  };

  $scope.formValues = {
    Name: '',
  };

  $scope.checkNameValidity = function (form) {
    var valid = true;
    for (var i = 0; i < $scope.tags.length; i++) {
      if ($scope.formValues.Name === $scope.tags[i].Name) {
        valid = false;
        break;
      }
    }
    form.name.$setValidity('validName', valid);
  };

  $scope.removeAction = removeAction;

  function removeAction(tags) {
    return $async(removeActionAsync, tags);
  }

  async function removeActionAsync(tags) {
    for (let tag of tags) {
      try {
        await TagService.deleteTag(tag.Id);

        Notifications.success('Готово', 'Тег «' + tag.Name + '» успешно удален');
        _.remove($scope.tags, tag);
      } catch (err) {
        Notifications.error('Ошибка', err, 'Не удалось удалить тег');
      }
    }

    $state.reload();
  }

  $scope.createTag = function () {
    var tagName = $scope.formValues.Name;
    TagService.createTag(tagName)
      .then(function success() {
        Notifications.success('Готово', 'Тег «' + tagName + '» успешно создан');
        $state.reload();
      })
      .catch(function error(err) {
        Notifications.error('Ошибка', err, 'Не удалось создать тег');
      });
  };

  function initView() {
    TagService.tags()
      .then(function success(data) {
        $scope.tags = data;
      })
      .catch(function error(err) {
        Notifications.error('Ошибка', err, 'Не удалось получить список тегов');
        $scope.tags = [];
      });
  }

  initView();
}
